import { useAuth } from "../AuthProvider";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  const { user, isAdminAuthorized, authLoading } = useAuth();
  if (authLoading) return <div className="p-6 text-sm text-gray-500">Loading…</div>;
  if (!user || !isAdminAuthorized) return <Navigate to="/login" replace />;
  return children;
}

export default ProtectedRoute;
